const getMonthList = (transactionDates) => {
  const optionTexts = [
    ...new Set(
      transactionDates.map((item) =>
        new Date(item.createdAt).toLocaleString('ro-RO', {
          month: 'long',
          year: 'numeric',
        })
      )
    ),
  ];

  const optionValues = [
    ...new Set(
      transactionDates.map((item) =>
        new Date(
          new Date(item.createdAt).getFullYear(),
          new Date(item.createdAt).getMonth(),
          1,
          0,
          0,
          0,
          0
        ).getTime()
      )
    ),
  ];

  return {
    optionTexts,
    optionValues,
  };
};

export default getMonthList;
